import EpicDisneyConfig from './config';

interface Params {
  launch?: string;
  client_id: string;
  redirect_uri: string;
  scope: string;
  response_type: string;
}

// we request authorization code both in Standalone launch and Embedded launch
export default function requestAuthorizationCode(launchToken: string | null) {
  const params: Params = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    client_id: EpicDisneyConfig.appOrchardAppId,
    // eslint-disable-next-line @typescript-eslint/camelcase
    redirect_uri: EpicDisneyConfig.redirectBackToKindbodyUrl(),
    // you can use scope: 'launch openid profile fhirUser' to get more data in response if you need it
    scope: 'openid fhirUser',
    // eslint-disable-next-line @typescript-eslint/camelcase
    response_type: 'code'
  };

  if (launchToken) {
    // with embedded launch, we are no asked again to login in MyChart
    // thanks to the launch token
    params.launch = launchToken;
    params.scope = 'launch openid fhirUser';
  }

  const url = `${EpicDisneyConfig.epicUrl}/oauth2/authorize`;
  window.location.replace(url + '?' + new URLSearchParams(params as any));
}
